<template>
  <section>
    <BannerTop />
    <div class="container custom-main">
      <router-view />
    </div>
  </section>
</template>

<script setup>
import BannerTop from '@/components/navigation/banner-top.vue'
</script>

<style scoped>
.custom-main {
  margin-top: 5px;
  padding: 10px;
}
</style>
